// extracted by mini-css-extract-plugin
export default {"matchBox":"chatwith_matchBox__4WvGd","chatBox":"chatwith_chatBox__0qLB-","chatLayout":"chatwith_chatLayout__DII2o","matchContainer":"chatwith_matchContainer__EtZmi"};